import React from "react";

const BookmarksLoader = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 py-6 px-1.5">
      {[...Array(Math.floor(Math.random() * 5) + 2)].map(
        (
          _,
          i // random between 2 and 6
        ) => (
          <div key={i} className="w-full overflow-hidden">
            <div className="bg-[#F4F4F5] rounded-xl animate-pulse">
              {/* Header */}
              <div className="flex items-center gap-3 p-4">
                <div className="w-12 h-12 rounded-xl bg-gray-300" />
                <div className="flex-1 min-w-0">
                  <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>

              {/* Links List Skeleton */}
              <div className="py-2 border bg-white rounded-xl border-gray-200 shadow-sm">
                {[...Array(3)].map((_, j) => (
                  <div key={j} className="flex items-center gap-3 px-4 py-2.5">
                    <div className="w-4 h-4 bg-gray-300 rounded-sm"></div>
                    <div className="h-3 bg-gray-300 rounded w-2/3"></div>
                  </div>
                ))}

                <div className="flex items-center gap-3 px-4 py-2.5">
                  <div className="w-4 h-4 bg-gray-200 rounded-sm"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/4"></div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default BookmarksLoader;
